<template>
  <ValidationObserver
    ref="observer"
    v-slot="{ valid, dirty }"
  >
    <v-row>
      <v-col>
        <VTextField
          v-model="data.name[selectedLang]"
          :label="`${$t('forms.labels.name')} (${$t(`langs.${selectedLang}`)})`"
          :rules="{ required: selectedLang === teamMainLang, min: 1, max: 200 }"
          outlined
          @input="updateData"
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="6">
        <VTextField
          v-model="data.density"
          type="number"
          :label="$t('coupons.density')"
          :rules="{ required: true, min: 1, max: 200 }"
          outlined
          @input="updateData"
        />
      </v-col>
      <v-col cols="6">
        <VTextField
          v-model="data.surface"
          type="number"
          :label="$t('coupons.surface')"
          :rules="{ required: true, min: 1, max: 200 }"
          outlined
          @input="updateData"
        />
      </v-col>
    </v-row>

    <v-row v-if="isEdition">
      <v-col>
        <VCheckbox
          v-model="data.active"
          :label="$t('forms.labels.active')"
          @input="updateData"
        />
      </v-col>
    </v-row>

    <SlotScopeWatcher
      :value="dirty"
      @change="$emit('dirtyChanged', dirty)"
    />
    <SlotScopeWatcher
      :value="valid"
      @change="$emit('validChanged', valid)"
    />
  </ValidationObserver>
</template>

<script>
import { mapGetters } from 'vuex';
import { ValidationObserver } from 'vee-validate';
import SlotScopeWatcher from '@/components/shared/widgets/forms/validationHelper/SlotScopeWatcher';
import VTextField from '@/components/shared/widgets/forms/VuetifyInputs/VTextField.vue';
import VCheckbox from '@/components/shared/widgets/forms/VuetifyInputs/VCheckbox.vue';

export default {
    components: {
        ValidationObserver,
        SlotScopeWatcher,
        VCheckbox,
        VTextField,
    },
    props: {
        coupon: {
            type: Object,
            default: () => ({ empty: true }),
        },
        isEdition: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            data: {
                name: {},
                surface: null,
                density: null,
                active: null,
            },
        };
    },
    computed: {
        ...mapGetters([
            'teamLangs',
            'userLang',
            'selectedLang',
            'teamMainLang',
        ]),
    },

    watch: {
        coupon: {
            handler() {
                if (!this.coupon.empty) {
                    this.data = this.coupon;
                }
            },
            immediate: true,
        },
        data: {
            handler() {
                this.updateData();
            },
            deep: true,
        },
    },
    methods: {
        updateData() {
            this.$emit('sendData', this.data);
        },
    },
};
</script>
